export default __webpack_public_path__ + "static/media/grafema_pilates_02.eba635e8.jpg";